module.exports = __webpack_public_path__ + "producr-dried fresh-grass-02.jpg?d3727b5dc7ca6a0506b4406d559e5af8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-02.jpg
// module id = 60
// module chunks = 0